<template>
  <div>
    <v-row justify="space-around" dense>
      <v-col cols="12" sm="6">
        <v-file-input
          v-model="filename"
          accept=".csv, .xls, .xlsx"
          label="File Excel"
          show-size
          outlined
          dense
          :disabled="disabled"
          prepend-icon=""
          prepend-inner-icon="$file"
          @change="onChange"
        ></v-file-input>
      </v-col>
      <v-col cols="12" sm="6">
        <v-select
          :items="sheetNames"
          dense
          outlined
          :disabled="disabled"
          :value="sheetNames && sheetNames[0]"
          @change="onChangeSheet"
        ></v-select>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import * as _ from 'lodash'
import * as XLSX from 'xlsx'
import * as dot from 'dot-object'

  export default {
    props: {
      modelloItem: Object,
      disabled: Boolean,
      resetFile: Number
    },
    data: () => ({
      filename: null,
      isLoading: false,
      nomeFile: '',
      colonneModello: [],
      showImporta: false,
      book: null,
      sheetNum: 0,
      sheetNames: []
    }),
    watch: {
      resetFile() {
        this.filename = null
      }
    },
    methods: {
      onChangeSheet(value) {
        this.sheetNum = this.sheetNames.indexOf(value)
        this.afterRead()
      },
      str2ab(str) {
        var buf = new ArrayBuffer(str.length)
        var bufView = new Uint8Array(buf)
        for (var i = 0, strLen = str.length; i < strLen; i++) {
          bufView[i] = str.charCodeAt(i)
        }
        return buf
      },
      onChange(file) {
        if (!file) {
          this.sheetNames = []
          this.sheetNum = 0
          this.book = null
          this.$emit('onLoaded', null)
          return
        }
        this.isLoading = true
        const nomeFile = file.name
        const fr = new FileReader()
        fr.readAsDataURL(file)
        fr.addEventListener('load', () => {
          this.nomeFile = nomeFile
          const content = fr.result
          const data = atob(content.substring(content.indexOf(',') + 1))
          var fileData = this.str2ab(data)
          const book = XLSX.read(fileData, { type: 'array' })
          this.book = book
          this.sheetNames = book.SheetNames
          this.afterRead()
          // this.afterRead(file.name, fr.result)
          this.isLoading = false
        })
      },
      afterRead() {
      /*afterRead(nomeFile, content) {
         this.nomeFile = nomeFile
        const data = atob(content.substring(content.indexOf(',') + 1))
        var fileData = this.str2ab(data)
        const book = XLSX.read(fileData, { type: 'array' }) */
        const book = this.book
        const sheetNum = this.sheetNum
        const sheetName = book.SheetNames[+sheetNum]
        const sheet = book.Sheets[sheetName]
        let dati = this.dataFromSheet(sheet)
        const datiPuliti = []
        if (dati) {
          const toDelete = Object.keys(dati[0]).filter(x => x.startsWith('__EMPTY'))
          if (toDelete) {
            dati.forEach(riga => {
              const rg = _.omit(riga, toDelete)
              if (!_.isEmpty(rg)) {
                datiPuliti.push(rg)
              }
            })
          }
          dati = null
        }
        // ****************  Elaborare i dati in base al modello  **********************
        const datiModello = []
        const codiceModello = this.modelloItem.codice
        if (codiceModello && datiPuliti.length > 0) {
          const modello = this.modelloItem
          let idxRiga = modello.prima_riga_dati || 2
          datiPuliti.forEach(riga => {
            const rigaM = {}
            modello.colonne.forEach(col => {
              if (col.colonnaSorgente) {
                rigaM[col.campo] = riga[col.colonnaSorgente]
              } else {
                const idx = col.colonna - 1
                /*               const keys = Object.keys(riga)
                const key = keys[idx]
                let valore = riga[key] */
                const colName = `${String.fromCharCode(65 + idx)}${idxRiga}`
                var cell = sheet[colName]
                let valore = (cell ? cell.v : '')
                if (col.fattore && valore) {
                  valore *= col.fattore
                }
                if (col.offset) {
                  valore += col.offset
                }
                if (col.decimali && valore) {
                  valore = +parseFloat(valore).toFixed(col.decimali)
                }
                rigaM[col.campo] = valore
              }
              if (typeof rigaM[col.campo] === 'string') {
                rigaM[col.campo] = rigaM[col.campo].trim()
              }
            })
            datiModello.push(rigaM)
            idxRiga++
          })
        }
        // *****************************************************************************
        // this.datiImport = datiModello.length > 0 ? datiModello : datiPuliti
        // this.datiImport[this.activeName] = datiModello.length > 0 ? datiModello : datiPuliti
/*         this.datiModello = datiModello
        this.datiPuliti = datiPuliti */
        // this.colonneModello = this.intestazioniColonneModello
        // this.htmlPreview = this.htmlFromSheet(sheet)
        this.isLoading = false
        this.showImporta = true
        const datiFlat = this.flatDatiRaw(datiPuliti)
        const datiResult = {
          nomeFile: this.nomeFile,
          datiModello,
          datiRaw: datiFlat,
          intestazioniModello: this.intestazioniColonneModello(datiModello),
          intestazioniRaw: this.intestazioniColonneRaw(datiFlat)
        }
        this.$emit('onLoaded', datiResult)
      },
      flatDatiRaw(dati) {
        let datiRaw = []
        for (let d of dati) {
          datiRaw.push(dot.dot(d)) 
        }
        return datiRaw
      },
      intestazioniColonneModello(dati) {
        if (!dati || dati.length === 0) {
          return []
        }
        const riga = dati[0]
        const keys = Object.keys(riga)
        const mdColonne = this.modelloItem.colonne || []
        let k = 0
        const colonne = keys.map(x => {
          const s = x.split('.')
          return { key: x, value: (mdColonne[k++].label || s[s.length - 1]).toUpperCase() }
        })
        return colonne
      },
      intestazioniColonneRaw(dati) {
        if (!dati || dati.length === 0) {
          return []
        }
        const riga = dati[0]
        // var dotRiga = dot.dot(riga);
        const keys = Object.keys(riga)
        const colonne = keys.map(x => {
          return { key: x, value: x.toUpperCase() }
        })
        return colonne
      },
      async asyncSome (arr, predicate) {
        for (const e of arr) {
          if (await predicate(e)) return true
        }
        return false
      },
      dataFromSheet(sheet) {
        const json = XLSX.utils.sheet_to_json(sheet)
        return this.dataFromJSON(json)
      },
      jsonFromSheet(sheet) {
        return XLSX.utils.sheet_to_json(sheet)
      },
      htmlFromSheet(sheet) {
        return XLSX.utils.sheet_to_html(sheet, { header: '', footer: '' })
      },
      dataFromJSON(json) {
        _.forEach(json, row => {
          dot.object(row)
        })
        return json
      }
    }
  }
</script>
